import { logger } from '@/utils/logger';

interface LoadScriptOptions {
  id?: string;
  onload?: () => void;
  onerror?: (event: Event | string) => void;
}

function appendScriptToDocument(
  src: string,
  { id, onload = () => {}, onerror = () => {} }: LoadScriptOptions = {},
): void {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = src;
  if (id) {
    script.id = id;
  }
  script.onload = () => {
    onload();
  };
  script.onerror = (event) => {
    logger.error(`Failed to load script: ${src}`);
    onerror(event);
  };
  const body = document.getElementsByTagName('body')?.[0];
  if (body) {
    body.insertBefore(script, body.lastElementChild);
  }
}

export function selectorContainsEventTarget(
  elemSelector: string,
  event: Event | undefined,
  element?: Document | Element,
): boolean {
  return [...(element || document).querySelectorAll(elemSelector)].some(
    (el) => el !== event?.target && el.contains(event?.target as Node),
  );
}

export function loadScript(src: string, options: LoadScriptOptions = {}): void {
  if (document.readyState === 'complete') {
    appendScriptToDocument(src, options);
  } else {
    window.addEventListener('load', () => appendScriptToDocument(src, options), false);
  }
}

let cssPageMediaStyle: HTMLStyleElement | null = null;

export function setCssPageMedia(rules: string): void {
  if (!cssPageMediaStyle) {
    cssPageMediaStyle = document.createElement(`style`);
    cssPageMediaStyle.setAttribute('id', 'cssPageMedia');
    document.head.appendChild(cssPageMediaStyle);
  }

  // no-dd-sa:javascript-browser-security/inner-outer-html
  cssPageMediaStyle.innerHTML = `@page { ${rules} }`;
}

export function detectPageScroll(): void {
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  if (html && body) {
    const scrollHeight = html.scrollHeight;
    const clientHeight = html.clientHeight;
    if (scrollHeight > clientHeight) {
      body.classList.add('scrollbar-padding');
    }
  }
}
